import React, { createContext, useEffect, useState } from "react";
import { StoredPaymentCardType } from "./payment-card-context.types";
import { PropsType } from "../../interfaces/ChildrenType";
import { StoredPaymentCard } from "../../interfaces/StoredPaymentCards";

const PaymentCards = sessionStorage.getItem("CEX-PaymentCards");

const initialState: StoredPaymentCardType = {
  paymentCards: JSON.parse(PaymentCards as string) || undefined,

  setPaymentCards: () => {},
};

export const PaymentCardsContext = createContext(initialState);

export const PaymentCardsContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [paymentCards, setPaymentCards] = useState<
    StoredPaymentCard[] | undefined
  >(initialState.paymentCards);

  useEffect(() => {
    if (paymentCards) {
      sessionStorage.setItem("CEX-PaymentCards", JSON.stringify(paymentCards));
    } else {
      sessionStorage.removeItem("CEX-PaymentCards");
    }
  }, [paymentCards]);

  return (
    <PaymentCardsContext.Provider value={{ paymentCards, setPaymentCards }}>
      {children}
    </PaymentCardsContext.Provider>
  );
};
